import { useState } from 'react'
import { Intestazione } from '../componenti/Pezzi.tsx'
import { useSessione } from '../servizi/sessione.tsx'
import { Utenti } from './UtentiSistema.tsx'
import { Ruoli } from './Ruoli.tsx'
import { Impostazioni } from './Impostazioni.tsx'

/**
 * Guscio dell'amministrazione: le tre sezioni storiche restano a linguette. Le sezioni nuove
 * si aggiungono come pagine con un percorso proprio, non qui dentro.
 */
export function Amministrazione() {
  const { puo } = useSessione()
  const [sezione, setSezione] = useState<'utenti' | 'ruoli' | 'impostazioni'>('utenti')
  // Impostazioni: chi non le legge ma cambia il termine delle firme di terzi (la Direzione, 458)
  // vede soltanto quello. Senza nessuno dei due la linguetta non compare.
  const sezioni = (['utenti', 'ruoli', 'impostazioni'] as const)
    .filter((s) => s !== 'impostazioni' || puo('impostazione.leggi') || puo('consenso.termine'))
  return (
    <>
      <Intestazione titolo="Amministrazione" />
      <div className="linguette" role="tablist">
        {sezioni.map((s) => (
          <button key={s} type="button" role="tab" aria-selected={sezione === s}
                  onClick={() => setSezione(s)}>
            {s[0].toUpperCase() + s.slice(1)}
          </button>
        ))}
      </div>
      {sezione === 'utenti' && <Utenti />}
      {sezione === 'ruoli' && <Ruoli />}
      {sezione === 'impostazioni' && <Impostazioni />}
    </>
  )
}
